export const AskVyrillError = () => {
  const SummaryError =
    require("@src/assets/images/vyrill/videos/SummaryError.png").default;
  return (
    <div className="ask-vyrill-prompt-error">
      <img className="error-image" src={SummaryError} />
      <div className="error-heading">
        We apologize, but an error has occurred on our end!
      </div>
      <div className="error-detail">
        We are looking into it. Please start a new session.{" "}
      </div>
    </div>
  );
};

export const AskVyrillTimeOutError = () => {
  const timeoutError =
    require("@src/assets/images/vyrill/timeout_error.png").default;

  return (
    <div className="ask-vyrill-prompt-error">
      <img className="error-image" src={timeoutError} />
      <div className="error-heading">
        We are sorry, this session has timed out!
      </div>
      <div className="error-detail">Please start a new session by typing in the Ask Vyrill bar below.</div>
    </div>
  );
};
